function getValidationError(path, errors) {
    if (path === null || path === undefined) {
        return null
    }

    function compare(a, b) {
        if (a.length !== b.length) {
            return false
        }
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) {
                return false
            }
        }
        return true
    }
    if (errors === undefined) {
        return null
    }
    for (let i = 0; i < errors.length; i++) {
        if (compare(errors[i].loc, path)) {
            return errors[i]
        }
    }
    return null
}

export {getValidationError};